<template>
  <v-select
    v-model="selectedItem"
    :items="items"
    outlined
    append-inner-icon="mdi-magnify"
    dense
    hide-details
  />
</template>

<script>
import helpers from '@common/utils/helpers'

export default {
    props:{
        criterio: {
          default: '',
          required: false,
        }
    },
    data() {
        return {
            selectedItem: null,
            items: [],
            loading: false
        };
    },
    watch:{
      selectedItem(valor){
        let criterios = this.$store.getters['criterios/getCriterios']

        const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia)
          if(valor && itemEncontrado) {
            itemEncontrado['tipoContrato'] = valor
          }
      }
    },
    mounted() {
        this.fetchData()
        this.setup()
    },        
    methods: {
      setup(){
        let criterios = this.$store.getters['criterios/getCriterios']
        const itemEncontrado = criterios.find(item => item.sequencia === this.criterio.sequencia)
        
        if(itemEncontrado) {
            this.selectedItem = itemEncontrado.tipoContrato
        }
      },
      async fetchData() {
        this.items = helpers.TipoContratoEnum.sort(helpers.ordenarDropdown)
      }
    }
};
</script>   
